import { defineStore } from 'pinia'

import { useGlobalStore } from './global'

export const useStoreStore = defineStore('store', {
	state: () => {
		return {
			cart: {},
			cartLoading: false,
			collections: [],
			featured: [],
			showcases: [],
			filter: null,
		}
	},
	getters: {
		collection: (state) => {
			return (slug) =>
				state.collections.filter(function (c) {
					return c.slug == slug
				})[0] ?? null
		},
		featuredCollection: (state) => {
			return (
				state.collections.filter(function (c) {
					return c.featured != null
				})[0] ?? null
			)
		},
	},
	actions: {
		setup() {
			this.getCart()
			this.getCollections()
			this.getFeatured()
			this.getShowcases()
		},
		//
		setFilter(slug) {
			this.filter = slug != this.filter ? slug : null
		},
		getCollections() {
			return axios
				.get('/api/store/collections')
				.then((collections) => {
					this.collections = collections.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getFeatured() {
			return axios
				.get('/api/store/featured')
				.then((products) => {
					this.featured = products?.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getShowcases() {
			return axios
				.get('/api/store/showcases')
				.then((showcases) => {
					this.showcases = showcases.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		//
		getCart() {
			//   if(cookies.isKey('shopify')) {
			this.cartLoading = true
			axios
				.get('/api/store/cart')
				.then((cart) => {
					this.cartLoading = false
					this.cart = cart.data
				})
				.catch((error) => {
					throw error
				})
			//   }
		},
		addToCart(variant) {
			const global = useGlobalStore()
			global.cart = true
			this.cartLoading = true
			return axios
				.post('/api/store/cart', {
					variantId: variant.id,
					quantity: variant.quantity ?? 1,
				})
				.then((cart) => {
					this.cart = cart.data
					this.cartLoading = false
				})
				.catch((error) => {
					throw error
				})
		},
		updateCart(cartItem) {
			this.cartLoading = true
			return axios
				.post('/api/store/cart/update', {
					id: cartItem.id,
					quantity: cartItem.quantity ?? 1,
				})
				.then((cart) => {
					this.cart = cart.data
					this.cartLoading = false
					return cart.data
				})
				.catch((error) => {
					throw error
				})
		},
	},
})
